<ng-container
  *ngIf="
    !isEnjoy &&
    segmentLoaded &&
    !isPending &&
    !isActive &&
    (displayedPrice || showPriceForFree) &&
    !isFree &&
    !isIncluded &&
    !option.customPrices &&
    !(option && isNetflixBuyAndSell(option) && netflixBuyAndSell == NetflixBuyAndSellStatus.ACTIVE)
  "
>
  <del *ngIf="!priceEquals && !priceIsZero">
    <px-currency-amount [amount]="price.toString()"></px-currency-amount>
  </del>
  <span *ngIf="asOfActive">
    {{'tv.asOfLabel' | translate }}
  </span>
  <px-currency-amount
    [amount]="displayedPrice.toString()"
    [amountClass]="computedAmountClass"
  ></px-currency-amount
  ><ng-container>{{ option.price | chargeFrequency: 'chargeFrequency' }}</ng-container>
</ng-container>
<ng-container
  *ngIf="
    segmentLoaded &&
    !isPending &&
    (!isActive || (isActive && option.customPrices)) &&
    !(option && isNetflixBuyAndSell(option) && netflixBuyAndSell == NetflixBuyAndSellStatus.ACTIVE)
  "
>
  <ng-container *ngFor="let price of option?.customPrices?.prices; let last = last">
    <span *ngIf="isCustomPriceZero(price)" [ngClass]="includedLabelClass">
      <span class="rs-euro" [ngClass]="includedLabelClass">{{
        'price.includedLabel' | translate
      }}</span>
    </span>
    <span *ngIf="!isCustomPriceZero(price) && !isActive">
       <span *ngIf="asOfActive">
        {{'tv.asOfLabel' | translate }}
      </span>
      <px-currency-amount
        [amount]="isVatIncl ? price.priceVat.toString() : price.priceNoVat.toString()"
        [amountClass]="customPriceAmountClass"
      ></px-currency-amount>
      <ng-container
        >{{ price | chargeFrequency: 'frequency'
        }}<span *ngIf="last && option.customPrices.asteriksFootnote">*</span></ng-container
      >
      <ng-container *ngIf="!last"
        >&nbsp;{{
          option.customPrices.separator[languageService.getSelectedLanguage()]
        }}&nbsp;</ng-container
      >
    </span>
  </ng-container>
</ng-container>
<span *ngIf="!isPending && isIncluded && !option.customPrices" [ngClass]="includedLabelClass">
  <span class="rs-euro" [ngClass]="includedLabelClass">{{
    'price.includedLabel' | translate
  }}</span>
</span>
<span
  *ngIf="
    isEnjoy &&
    !isPending &&
    (!isActive || !showActiveStatus) &&
    isFree &&
    !isIncluded &&
    !option.customPrices
  "
  class="{{ computedAmountClass }}"
>
  <span class="rs-euro">{{ 'price.enjoyLabel' | translate }}</span>
</span>
<span
  *ngIf="
    !isPending &&
    (!isActive || !showActiveStatus) &&
    isFree &&
    !isIncluded &&
    !option.customPrices &&
    !isEnjoy
  "
  class="{{ computedAmountClass }}"
  ><span class="rs-euro">{{ 'price.freeLabel' | translate }}</span></span
>
<span
  *ngIf="
    !isPending &&
    option &&
    isNetflixBuyAndSell(option) &&
    netflixBuyAndSell == NetflixBuyAndSellStatus.ACTIVE
  "
  class="rs-txt-s6"
  [ngClass]="activeLabelClass"
  >{{ 'price.includedInPack' | translate }}</span
>

<div *ngIf="showDisneyPlusStatus && showActiveStatus">
  <span *ngIf="isDisneyPlusActive(option)" class="rs-font-pxB" [ngClass]="activeLabelClass"
    ><i class="icon-Status-ok rs-margin-right1" aria-hidden="true"></i
    >{{ 'tv.active.options.disneyplus.activated' | translate }}</span
  >

  <span *ngIf="isDisneyPlusNotActive(option)" class="rs-font-pxB" [ngClass]="warningLabelClass"
    ><i class="icon-Stopwatch rs-margin-right1" aria-hidden="true"></i
    >{{ 'tv.active.options.disneyplus.notactivated' | translate }}</span
  >
</div>

<span
  *ngIf="
    !isIncluded &&
    !isPending &&
    isActive &&
    showActiveStatus &&
    !showNetflixStatus &&
    !showDisneyPlusStatus
  "
  class="rs-font-pxB"
  [ngClass]="activeLabelClass"
  ><i class="icon-Status-ok rs-margin-right1" aria-hidden="true"></i
  >{{ 'common.options.active' | translate }}</span
>

<span *ngIf="isPending" class="rs-font-pxB" [ngClass]="warningLabelClass"
  ><i class="icon-Stopwatch rs-margin-right1" aria-hidden="true"></i
  >{{ 'common.options.pending' | translate }}</span
>
